import {
  CHANGE_ALERT_FORM,
  CHANGE_PAPERLESS_FORM,
  CHANGE_STEP,
  CLOSE_MODAL_STATE,
  FETCH_ALERT_SETTINGS,
  FETCH_ALERT_SETTINGS_FAILURE,
  FETCH_ALERT_SETTINGS_SUCCESS,
  FETCH_PAPERLESS_SETTING_ALL,
  FETCH_PAPERLESS_SETTING_ALL_FAILURE,
  FETCH_PAPERLESS_SETTING_ALL_SUCCESS,
  OPEN_MODAL_STATE,
  PUT_ALERT_SETTINGS,
  PUT_ALERT_SETTINGS_FAILURE,
  PUT_ALERT_SETTINGS_SUCCESS,
  PUT_PAPERLESS_SETTING,
  PUT_PAPERLESS_SETTING_FAILURE,
  PUT_PAPERLESS_SETTING_SUCCESS,
  RESET_FORM_STATE,
  RESET_STATUS_STATE,
  SET_SELECTED_LOAN,
} from './constants';

export function changeAlertForm({ alertId, field }) {
  return {
    payload: { alertId, field },
    type: CHANGE_ALERT_FORM,
  };
}

export function changePaperlessForm(loanNumber) {
  return {
    payload: { loanNumber },
    type: CHANGE_PAPERLESS_FORM,
  };
}

export function changeStep(step) {
  return {
    payload: { step },
    type: CHANGE_STEP,
  };
}

export function closeModalState() {
  return { type: CLOSE_MODAL_STATE };
}

export function fetchAlertSettings() {
  return { type: FETCH_ALERT_SETTINGS };
}

export function fetchAlertSettingsFailure(error) {
  return {
    payload: { error },
    type: FETCH_ALERT_SETTINGS_FAILURE,
  };
}

export function fetchAlertSettingsSuccess({ currentSetting, profile }) {
  return {
    payload: { currentSetting, profile },
    type: FETCH_ALERT_SETTINGS_SUCCESS,
  };
}

export function fetchPaperlessSettingAll() {
  return { type: FETCH_PAPERLESS_SETTING_ALL };
}

export function fetchPaperlessSettingAllFailure(error) {
  return {
    payload: { error },
    type: FETCH_PAPERLESS_SETTING_ALL_FAILURE,
  };
}

export function fetchPaperlessSettingAllSuccess(currentPaperlessSettings) {
  return {
    payload: { currentPaperlessSettings },
    type: FETCH_PAPERLESS_SETTING_ALL_SUCCESS,
  };
}

export function openModalState({ modalState }) {
  return {
    payload: { modalState },
    type: OPEN_MODAL_STATE,
  };
}

export function putAlertSettings() {
  return { type: PUT_ALERT_SETTINGS };
}

export function putAlertSettingsFailure(error) {
  return {
    payload: { error },
    type: PUT_ALERT_SETTINGS_FAILURE,
  };
}

export function putAlertSettingsSuccess() {
  return { type: PUT_ALERT_SETTINGS_SUCCESS };
}

export function putPaperlessSetting() {
  return { type: PUT_PAPERLESS_SETTING };
}

export function putPaperlessSettingFailure(error) {
  return {
    payload: { error },
    type: PUT_PAPERLESS_SETTING_FAILURE,
  };
}

export function putPaperlessSettingSuccess() {
  return { type: PUT_PAPERLESS_SETTING_SUCCESS };
}

export function resetFormState() {
  return { type: RESET_FORM_STATE };
}

export function resetStatusState(statusKeys) {
  return {
    payload: { statusKeys },
    type: RESET_STATUS_STATE,
  };
}

export function setSelectedLoan(loanNumber) {
  return {
    payload: { loanNumber },
    type: SET_SELECTED_LOAN,
  };
}
